import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { ConfirmProvider } from './context/ConfirmContext';
import { NotificationProvider } from './context/NotificationContext';
import PrivateRoute from './components/PrivateRoute';
import RoleRoute from './components/RoleRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Unauthorized from './pages/Unauthorized';
import Notifications from './pages/Notifications';

// Admin
import AdminDashboard from './pages/admin/AdminDashboard';
import ManageUniversites from './pages/admin/ManageUniversites';
import ManageFacultes from './pages/admin/ManageFacultes';
import ManagePromotions from './pages/admin/ManagePromotions';
import ManageUsers from './pages/admin/ManageUsers';

// Enseignant
import EnseignantDashboard from './pages/enseignant/EnseignantDashboard';
import EnseignantCours from './pages/enseignant/EnseignantCours';
import EnseignantEvaluations from './pages/enseignant/EnseignantEvaluations';
import EnseignantNotes from './pages/enseignant/EnseignantNotes';
import EnseignantQCM from './pages/enseignant/EnseignantQCM';
import EnseignantSeances from './pages/enseignant/EnseignantSeances';
import EnseignantCopies from './pages/enseignant/EnseignantCopies';

// Étudiant
import EtudiantDashboard from './pages/etudiant/EtudiantDashboard';
import EtudiantCours from './pages/etudiant/EtudiantCours';
import EtudiantEvaluations from './pages/etudiant/EtudiantEvaluations';
import EtudiantNotes from './pages/etudiant/EtudiantNotes';
import PasserQCM from './pages/etudiant/PasserQCM';
import EtudiantSoumissions from './pages/etudiant/EtudiantSoumissions';

// Shared
import StatsAvancees from './pages/StatsAvancees';
import Profile from './pages/Profile';

import './App.css';

function HomeRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'admin') return <Navigate to="/admin/dashboard" replace />;
  if (user.role === 'enseignant') return <Navigate to="/enseignant/dashboard" replace />;
  return <Navigate to="/etudiant/dashboard" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
        <ConfirmProvider>
        <NotificationProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Protected routes with shared Layout */}
          <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
            {/* Notifications (tous rôles) */}
            <Route path="/notifications" element={<Notifications />} />

            {/* Admin */}
            <Route path="/admin/dashboard" element={<RoleRoute roles={['admin']}><AdminDashboard /></RoleRoute>} />
            <Route path="/admin/universites" element={<RoleRoute roles={['admin']}><ManageUniversites /></RoleRoute>} />
            <Route path="/admin/facultes" element={<RoleRoute roles={['admin']}><ManageFacultes /></RoleRoute>} />
            <Route path="/admin/promotions" element={<RoleRoute roles={['admin']}><ManagePromotions /></RoleRoute>} />
            <Route path="/admin/users" element={<RoleRoute roles={['admin']}><ManageUsers /></RoleRoute>} />
            <Route path="/stats" element={<RoleRoute roles={['admin','enseignant','etudiant']}><StatsAvancees /></RoleRoute>} />
            <Route path="/profile" element={<Profile />} />

            {/* Enseignant */}
            <Route path="/enseignant/dashboard" element={<RoleRoute roles={['enseignant']}><EnseignantDashboard /></RoleRoute>} />
            <Route path="/enseignant/cours" element={<RoleRoute roles={['enseignant']}><EnseignantCours /></RoleRoute>} />
            <Route path="/enseignant/evaluations" element={<RoleRoute roles={['enseignant']}><EnseignantEvaluations /></RoleRoute>} />
            <Route path="/enseignant/notes" element={<RoleRoute roles={['enseignant']}><EnseignantNotes /></RoleRoute>} />
            <Route path="/enseignant/qcm" element={<RoleRoute roles={['enseignant']}><EnseignantQCM /></RoleRoute>} />
            <Route path="/enseignant/seances" element={<RoleRoute roles={['enseignant']}><EnseignantSeances /></RoleRoute>} />
            <Route path="/enseignant/copies" element={<RoleRoute roles={['enseignant']}><EnseignantCopies /></RoleRoute>} />

            {/* Étudiant */}
            <Route path="/etudiant/dashboard" element={<RoleRoute roles={['etudiant']}><EtudiantDashboard /></RoleRoute>} />
            <Route path="/etudiant/cours" element={<RoleRoute roles={['etudiant']}><EtudiantCours /></RoleRoute>} />
            <Route path="/etudiant/evaluations" element={<RoleRoute roles={['etudiant']}><EtudiantEvaluations /></RoleRoute>} />
            <Route path="/etudiant/notes" element={<RoleRoute roles={['etudiant']}><EtudiantNotes /></RoleRoute>} />
            <Route path="/etudiant/soumissions" element={<RoleRoute roles={['etudiant']}><EtudiantSoumissions /></RoleRoute>} />
            <Route path="/etudiant/qcm/:evaluationId" element={<RoleRoute roles={['etudiant']}><PasserQCM /></RoleRoute>} />
          </Route>

          <Route path="*" element={<HomeRedirect />} />
        </Routes>
        </NotificationProvider>
        </ConfirmProvider>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
